import { freeze } from "immer";

export const ProducerTab = freeze(
  {
    General: "general",
    UsedInRecipes: "used-in-recipes",
  } as const,
  true,
);
